// extracted by mini-css-extract-plugin
module.exports = {"scroll-down":"scrolldown_scroll-down__1KP4D","scroldown":"scrolldown_scroldown__3O4sG"};